<template>
  <div>
    <b-card class="md-3">
      <!-- Tabla con la lista de dispositivos-->
      <b-card-text class="nodeTable">
        <div>
          <vue-good-table
            :columns="columns"
            :rows="rows"
            :totalRows="totalRecords"
            :search-options="{
              enabled: true,
              //trigger: 'enter',
              skipDiacritics: true,
              //searchFn: mySearchFn,
              placeholder: 'Buscar en la tabla',
              //externalQuery: searchQuery
            }"
            :sort-options="{
              enabled: true,
              initialSortBy: { field: 'aliasnodo', type: 'asc' },
            }"
            :pagination-options="{
              enabled: true,
              mode: 'records',
              perPage: 10,
              dropdownAllowAll: false,
              //setCurrentPage: 2,
              nextLabel: '',
              prevLabel: '',
              rowsPerPageLabel: 'Filas por pagina',
              ofLabel: 'de',
              pageLabel: 'pagina', // for 'pages' mode
              allLabel: 'Todas',
            }"
            :isLoading.sync="isLoading"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'acciones'">
                <a href="#content" style="color: #606266 !important">
                  <span
                    style="margin-right: 10px"
                    @click="editRow(props.row.idnodo)"
                  >
                    <i class="far fa-edit fa-lg" style="cursor: pointer"></i>
                  </span>
                </a>
                <span
                  @click="deleteModalPopup(props.row.idnodo)"
                  v-if="isUserAdmin()"
                >
                  <i class="far fa-trash-alt fa-lg" style="cursor: pointer">
                  </i>
                </span>
              </span>
            </template>

            <template slot="loadingContent">
              <table-loading />
            </template>
            <template slot="emptystate">
              <table-empty-state />
            </template>
          </vue-good-table>
        </div>
      </b-card-text>
    </b-card>
    <!-- MODAL PARA BARRAR -->
    <Modal ref="borrarModal" :title="modalTitle" size="md">
      <template #content>
        <div style="font-size: 90%">
          <div class="modal-body">
            <p>
              Recuerde que una vez borrada el nodo no podra ser recuperado de
              nuevo.
            </p>
            <b-row>
              <b-col>
                <div class="form-check" style="cursor:pointer;">
                  <input
                    class="form-check-input"
                    v-model="deleteSensorFlag"
                    type="checkbox"
                    name="deleteSensorFlag"
                    id="deleteSensorFlag"
                  />
                  <label class="form-check-label" for="deleteSensorFlag" style="cursor:pointer;"
                    >Borrar sensores asociados al nodo</label
                  >
                </div>
              </b-col>
            </b-row>
          </div>
          <div class="modal-footer p-2">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              data-dismiss="modal"
              @click="dismissModal"
            >
              No, me he equivocado
            </button>
            <button
              type="button"
              class="btn btn-danger btn-sm"
              @click="performNodeDelete"
            >
              Si, quiero borrarlo
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <!-- MODAL PARA BARRAR -->
  </div>
</template>


<script>
// MIRAR EN https://xaksis.github.io/vue-good-table/guide/
import Modal from "@/components/common/Modal";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import DeviceService from "@/services/DeviceService";
import UserService from "@/services/UserService";
import TableLoading from "@/components/common/TableLoading";
import TableEmptyState from "@/components/common/TableEmptyState";

export default {
  name: "device-list",
  data() {
    return {
      device: [],
      currentDevice: null,
      currentIndex: -1,
      alias: "",
      modalTitle: "",
      deleteSensorFlag: false,
      isLoading: false,
      tempId: null,
      totalRecords: 0,
      columns: [
        {
          label: "# UUID",
          thClass: "text-center",
          tdClass: "text-center",
          field: "uuid",
        },
        {
          label: "Alias nodo",
          field: "aliasnodo",
          type: "string",
          thClass: "text-center",
          tdClass: "text-center",
          width: "15%",
        },
        {
          label: "SIM",
          field: "simId",
          type: "string",
          thClass: "text-center",
          tdClass: "text-center",
          width: "400",
          hidden: true
        },
        {
          label: "Tipología nodo",
          field: "tipologianodo",
          thClass: "text-center",
          tdClass: "text-center",
          type: "string",
          hidden: true,
        },
        {
          label: "CP",
          field: "zipnodo",
          thClass: "text-center",
          tdClass: "text-center",
          type: "string",
          hidden: true,
        },
        {
          label: "Provincia",
          field: "provincianodo",
          thClass: "text-center",
          tdClass: "text-center",
          type: "string",
          hidden: true,
        },
        {
          label: "Latitud",
          field: "latitudnodo",
          thClass: "text-center",
          tdClass: "text-center",
          type: "string",
          hidden: true,
        },
        {
          label: "Longitud",
          field: "longitudnodo",
          thClass: "text-center",
          tdClass: "text-center",
          type: "string",
          hidden: true,
        },
        {
          label: "Firmware",
          field: "firmware",
          type: "string",
          thClass: "text-center",
          tdClass: "text-center",
          width: "400",
        },         
        {
          label: "Asociado a",
          thClass: "text-center",
          tdClass: "text-center",
          field: "locationnodo",
        },
        {
          label: "Estado nodo",
          thClass: "text-center",
          tdClass: "text-center",
          field: "estadonodo",
        },
        {
          label: "Sensores vinculados",
          thClass: "text-center",
          tdClass: "text-center",
          field: "sensoresnodo",
          hidden: true,
        },
        {
          label: "Incidencias",
          thClass: "text-center",
          tdClass: "text-center",
          field: "incidenciasnodo",
          hidden: true,
        },
        {
          label: "Última modificación",
          thClass: "text-center",
          tdClass: "text-center",
          field: "fechaactualizacionnodo",
        },
        {
          label: "Acciones",
          thClass: "text-center",
          tdClass: "text-center",
          field: "acciones",
        },
        {
          label: "idnodo",
          field: "idnodo",
          hidden: true,
        },
      ],
      rows: [],
    };
  },
  components: {
    VueGoodTable,
    "table-loading": TableLoading,
    "table-empty-state": TableEmptyState,
    Modal,
  },
  methods: {
    retrieveDevice() {
      this.isLoading = true;
      DeviceService.getAll()
        .then((response) => {
          this.device = response.data;
          this.totalRecords = response.data.length;

          //Cuidado esto puede cortar el lleado del array
          //en caso de que no exista algún campo
          this.populateRows();
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
          console.log(e);
        });
    },

    refreshList() {
      this.rows = [];
      this.retrieveDevice();
    },

    deleteDevice(idnodo) {
      // If deleteSensorFlag is true, se borran los
      // sensores viunculados al nodo
      DeviceService.delete(idnodo, this.deleteSensorFlag)
        .then((response) => {
          let texto = "No existen elementos que desvincular";
          if (response.data.updatedChildren > 0) {
            texto =
              "Han quedado desvinculados " +
              response.data.updatedChildren +
              " sensore(s)";
          }
          //Mostrar mensaje
          this.$notify({
            group: "notificateDiv",
            type: "pepito",
            title: "Nodo eliminado correctamente",
            text: texto,
            duration: 3000,
            speed: 1000,
          });
          //Quitar del array caragdo la Fila
          this.refreshList();
          this.tempId = null;
          this.deleteSensorFlag = false;
          //Refrescar tabla
        })
        .catch((e) => {
          console.log(e);
        });
    },

    populateRows() {
      //Create struct before insert it
      let newData = null;
      let nSensor = 0;

      //Add to array
      for (let i = 0; i < this.device.length; i++) {
        nSensor = 0;
        DeviceService.getSensorCount(this.device[i]._id)
          .then((response) => {
            nSensor = parseInt(response.data, 10);

            //Fill the struct
            newData = {
              uuid: this.device[i].uuid,
              aliasnodo: this.device[i].alias,
              tipologianodo: this.device[i].type,
              simId: this.device[i].simId,
              zipnodo: this.device[i].location
                ? this.device[i].location.zip
                : " - ",
              provincianodo: this.device[i].location
                ? this.device[i].location.province
                : " - ",
              latitudnodo: this.device[i].location
                ? this.device[i].location.latitude
                : " - ",
              longitudnodo: this.device[i].location
                ? this.device[i].location.longitude
                : " - ",
              locationnodo: this.device[i].location_ref
                ? this.device[i].location_ref.alias
                : "No asociado",
              firmware: this.device[i].firmware && this.device[i].firmware.version ? this.device[i].firmware.version : "-",
              estadonodo: this.device[i].status ? "Activo" : "Inactivo",
              sensoresnodo: nSensor ? nSensor : 0,
              incidenciasnodo: -1,
              fechaactualizacionnodo: this.$moment(
                String(this.device[i].updatedAt)
              )
                .local()
                .format("DD/MM/YYYY HH:mm:ss"),
              idnodo: this.device[i]._id,
              /*Be carefull -> inverted quote to multiple html lines -> Now as slot*/
              /*acciones: ''*/
            };
            //Push the data to the array
            this.rows.push(newData);
          })
          .catch((e) => {
            console.log("Error poblando tabla de nodos");
            console.log(e);
          });
      }
    },

    editRow(idnodo) {
      //Emit from child to parent idnodo to be modified
      this.$emit("rowedit", idnodo);
    },

    deleteModalPopup(idnodo) {
      //Ver si hay que poner el modal en modo edición o como nuevo psando el ID
      this.modalTitle =
        "¿Estad usted seguro de borrar el nodo seleccionado del sistema?";

      if (idnodo) {
        this.$nextTick(() => {
          // DOM updated
          this.$refs.borrarModal.show();
          this.tempId = idnodo;
        });
      }
    },

    dismissModal(){
       this.$refs.borrarModal.hide();
    },

    async performNodeDelete() {
      // TempID temporal id to be deleted
      if (this.tempId != null) {
        await this.deleteDevice(this.tempId);
        this.$refs.borrarModal.hide();
      }
    },

    isUserAdmin() {
      return UserService.isUserAdmin();
    },
  },
  mounted() {
    this.retrieveDevice();
  },
};
</script>

<style>
.nodeTable {
  padding: 20px 20px 20px 20px;
}
</style>
